import { render, staticRenderFns } from "./dosageagreement.vue?vue&type=template&id=6b21dc5d&"
var script = {}
import style0 from "./dosageagreement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports